import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { ContactSection } from "@/components/ContactSection";
import { Reveal } from "@/components/Reveal";

const FAQS = [
  {
    q: "Do you sell to private buyers?",
    a: "Sunrays is trade-first — jewelers, retailers, and wholesale buyers. Private clients are welcomed by referral or for bespoke sourcing commissions above a threshold; contact the desk to discuss.",
  },
  {
    q: "Is there a minimum order?",
    a: "Single certified stones from 0.30ct carry no minimum. Calibrated melee and matched parcels are quoted per parcel with volume positioning.",
  },
  {
    q: "Natural or lab-grown — which should I stock?",
    a: "Both desks are active. Natural holds heirloom value and margin on statement goods; lab-grown turns faster at entry price points. The Market Explorer shows indicative positioning for each — and the desk will talk it through honestly.",
  },
  {
    q: "Can I view stones before committing?",
    a: "Yes. Viewings at our JLT office are by appointment, and memo terms are available to established accounts with references.",
  },
  {
    q: "How are stones shipped?",
    a: "Fully insured, armored door-to-door carriage with chain-of-custody documentation. Stock can also be held in bonded JLT vaulting for call-off schedules.",
  },
];

export const ContactPage = () => (
  <div className="pt-24" data-testid="contact-page">
    <header className="mx-auto max-w-7xl px-6 pt-16 lg:px-12">
      <Reveal>
        <p className="eyebrow mb-4">Contact</p>
        <h1 className="font-display max-w-3xl text-4xl font-light leading-[1.08] tracking-tight text-white sm:text-5xl lg:text-6xl">
          One brief away from <span className="gold-text italic">your next stone</span>
        </h1>
      </Reveal>
    </header>

    <ContactSection />

    <section className="mx-auto max-w-4xl px-6 pb-28 lg:px-12" data-testid="contact-faq">
      <Reveal>
        <p className="eyebrow mb-4">Before you ask</p>
        <h2 className="font-display text-3xl font-light text-white sm:text-4xl">Frequent questions</h2>
      </Reveal>
      <Reveal delay={0.1}>
        <Accordion type="single" collapsible className="mt-10">
          {FAQS.map((f, i) => (
            <AccordionItem key={i} value={`faq-${i}`} className="border-white/10" data-testid={`faq-${i}`}>
              <AccordionTrigger className="font-display text-left text-xl font-light text-white hover:text-[#E8DCC0] hover:no-underline">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-sm leading-relaxed text-[#B8BCC2]">{f.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </section>
  </div>
);
